import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _regeneratorRuntime from "@babel/runtime/helpers/regeneratorRuntime";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
var _Custom, _Loading;
import { useEffect, useMemo, useState } from 'react';
import { useAmplitude } from '@crehana/analytics';
import CloseSmall from '@crehana/icons/outline/CloseSmall';
import { colors } from '@crehana/tailwindcss';
// biome-ignore lint/style/noRestrictedImports: legacy import, will be migrated
import { IconButton, TextTag } from '@crehana/ui';
import cn from 'clsx';
import { usePlaybackContext } from "../../context/Playback";
import { useUIContext } from "../../context/UI";
import { useTranslation } from "../../hooks";
import Custom from "./Custom";
import Loading from "./Loading";
import Suggestions from "./Suggestions";
import { WarningNotes } from "./WarningNotes";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var GenerateNote = function GenerateNote() {
  var _Suggestions;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useUIContext = useUIContext(),
    toogleGeneratedAI = _useUIContext.toogleGeneratedAI,
    changeGenerateAI = _useUIContext.changeGenerateAI,
    stateGenerateAI = _useUIContext.stateGenerateAI,
    onAddNoteAI = _useUIContext.onAddNoteAI,
    onSaveNoteAI = _useUIContext.onSaveNoteAI,
    canWarningNoteAI = _useUIContext.canWarningNoteAI,
    amplitudAI = _useUIContext.amplitudAI,
    sourceAI = _useUIContext.sourceAI,
    setRenderAI = _useUIContext.setRenderAI,
    getRenderAI = _useUIContext.getRenderAI;
  var _usePlaybackContext = usePlaybackContext(),
    loading = _usePlaybackContext.loading,
    onSkip = _usePlaybackContext.onSkip;
  var _useAmplitude = useAmplitude(),
    logEvent = _useAmplitude.logEvent;
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    dataNote = _useState2[0],
    setDataNote = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isVisibleToast = _useState4[0],
    setIsVisibleToast = _useState4[1];
  var _useState5 = useState(),
    _useState6 = _slicedToArray(_useState5, 2),
    dataNoteSelect = _useState6[0],
    selectNotes = _useState6[1];
  var _useState7 = useState(0),
    _useState8 = _slicedToArray(_useState7, 2),
    noteSelectAux = _useState8[0],
    setNoteSelectAux = _useState8[1];
  var _useState9 = useState({
      type: 'none'
    }),
    _useState0 = _slicedToArray(_useState9, 2),
    contentToast = _useState0[0],
    setContentToast = _useState0[1];
  var _useState1 = useState(false),
    _useState10 = _slicedToArray(_useState1, 2),
    hasSelectSuggestions = _useState10[0],
    setHasSelectSuggestions = _useState10[1];
  var _useState11 = useState(false),
    _useState12 = _slicedToArray(_useState11, 2),
    canSave = _useState12[0],
    setCanSave = _useState12[1];
  var stateSuggestion = stateGenerateAI === 'suggestions' || stateGenerateAI === 'successNoteEmpty';
  var returnContent = function returnContent() {
    // biome-ignore lint/style/useBlockStatements: single-line early return
    if (stateGenerateAI === 'custom') return _Custom || (_Custom = /*#__PURE__*/_jsx(Custom, {}));
    // biome-ignore lint/style/useBlockStatements: single-line early return
    if (stateGenerateAI === 'loading') return _Loading || (_Loading = /*#__PURE__*/_jsx(Loading, {}));
    // biome-ignore lint/style/useBlockStatements: single-line early return
    if (stateGenerateAI === 'successNoteEmpty' || stateGenerateAI === 'suggestions') return _Suggestions || (_Suggestions = /*#__PURE__*/_jsx(Suggestions, {
      canSelect: setHasSelectSuggestions,
      isSaveNote: canSave,
      noteSuggestions: dataNote,
      selectNotes: selectNotes
    }));
  };
  var returnCtaButton = useMemo(function () {
    // biome-ignore lint/style/useBlockStatements: single-line early return
    if (stateGenerateAI === 'suggestions') return 'AI_CTA_BUTTON_SAVE';
    // biome-ignore lint/style/useBlockStatements: single-line early return
    if (stateGenerateAI === 'loading') return 'CANCEL';
    // biome-ignore lint/style/useBlockStatements: single-line early return
    if (stateGenerateAI === 'successNoteEmpty') return 'AI_SUCCESS_LABEL';
    return 'AI_SUCCES_LABEL';
  }, [stateGenerateAI]);
  var disabledButtonAction = !hasSelectSuggestions && stateGenerateAI === 'suggestions';
  var eventAmplitudGenerate = function eventAmplitudGenerate(sizeData, isSuccess) {
    logEvent({
      event: 'AI Notes Generated',
      data: {
        'Total Notes Generated': sizeData,
        Successful: isSuccess
      }
    });
  };
  var generateNoteAction = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var newData;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!onAddNoteAI) {
              _context.next = 17;
              break;
            }
            changeGenerateAI('loading');
            _context.prev = 2;
            _context.next = 5;
            return onAddNoteAI();
          case 5:
            newData = _context.sent;
            eventAmplitudGenerate((newData === null || newData === void 0 ? void 0 : newData.length) || 0, true);

            // biome-ignore lint/style/useBlockStatements: single-line early return
            if (newData) setDataNote(newData);
            changeGenerateAI('suggestions');
            _context.next = 17;
            break;
          case 11:
            _context.prev = 11;
            _context.t0 = _context["catch"](2);
            setContentToast({
              type: 'error'
            });
            eventAmplitudGenerate(0, false);
            setIsVisibleToast(true);
            changeGenerateAI('custom');
          case 17:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[2, 11]]);
    }));
    return function generateNoteAction() {
      return _ref.apply(this, arguments);
    };
  }();
  var handleAction = function handleAction() {
    if (stateGenerateAI === 'suggestions') {
      setCanSave(true);
      return;
    }
    if (stateGenerateAI === 'successNoteEmpty') {
      logEvent({
        event: 'AI Continue Next Class',
        data: {
          'Total Notes Generated': dataNote === null || dataNote === void 0 ? void 0 : dataNote.length,
          'Total Notes Selected': noteSelectAux
        }
      });
      onSkip();
      toogleGeneratedAI(sourceAI);
    }
    void generateNoteAction();
  };

  // biome-ignore lint/correctness/useExhaustiveDependencies: dependencies are intentional
  useEffect(function () {
    // biome-ignore lint/style/useBlockStatements: single-line early return
    if (getRenderAI() === null || getRenderAI() === 'false') logEvent({
      event: 'Render AI Notes',
      data: _objectSpread(_objectSpread({}, amplitudAI), {}, {
        Source: sourceAI
      })
    });
    setRenderAI(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [amplitudAI, getRenderAI, setRenderAI, sourceAI]);
  useEffect(function () {
    if (canWarningNoteAI && canWarningNoteAI !== 'none') {
      setIsVisibleToast(true);
      setContentToast({
        type: canWarningNoteAI
      });
    }
  }, [canWarningNoteAI]);

  // biome-ignore lint/correctness/useExhaustiveDependencies: dependencies are intentional
  useEffect(function () {
    if (canSave && dataNoteSelect && (dataNoteSelect === null || dataNoteSelect === void 0 ? void 0 : dataNoteSelect.length) > 0 && onSaveNoteAI) {
      setCanSave(false);
      changeGenerateAI('loading');
      logEvent({
        event: 'AI Notes Saved',
        data: {
          'Total Notes Generated': dataNote === null || dataNote === void 0 ? void 0 : dataNote.length,
          'Total notes selected': dataNoteSelect === null || dataNoteSelect === void 0 ? void 0 : dataNoteSelect.length
        }
      });
      setNoteSelectAux(dataNoteSelect.length);
      onSaveNoteAI(dataNoteSelect);
      setDataNote(dataNote === null || dataNote === void 0 ? void 0 : dataNote.filter(function (itemDataNote) {
        return !dataNoteSelect.some(function (itemDataNoteSelect) {
          return itemDataNoteSelect.id === itemDataNote.id;
        });
      }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [canSave, changeGenerateAI, dataNote, dataNoteSelect, onSaveNoteAI]);
  useEffect(function () {
    // biome-ignore lint/style/useBlockStatements: single-line early return
    if (disabledButtonAction) setCanSave(false);
  }, [disabledButtonAction]);
  useEffect(function () {
    return function () {
      changeGenerateAI('custom');
      setRenderAI(false);
    };
  }, [changeGenerateAI, setRenderAI]);
  if (loading) {
    toogleGeneratedAI('none');
    return null;
  }
  return /*#__PURE__*/_jsxs("div", {
    className: cn('tw-dark tw-bottom-2  tw-w-full tw-h-full tw-absolute tw-z-5 tw-bg-[rgb(15 16 25 / 9%)] tw-backdrop-blur-[2px] tw-flex tw-items-center tw-justify-center'),
    children: [/*#__PURE__*/_jsxs("div", {
      className: cn('tw-text-neutral-light-100  tw-shadow-02 tw-bg-elevation-dark-00 tw-rounded-1 tw-overflow-hidden', stateGenerateAI === 'suggestions' || stateGenerateAI === 'successNoteEmpty' ? 'tw-w-[77rem]' : 'tw-w-[56rem]'),
      children: [/*#__PURE__*/_jsxs("section", {
        className: "tw-font-subtitle4 tw-flex tw-items-center tw-justify-between tw-pt-1.6 tw-pb-1.2 tw-border-b tw-border-solid tw-border-neutral-dark-700 tw-px-2.4",
        children: [/*#__PURE__*/_jsxs("span", {
          className: "tw-flex tw-items-center",
          children: [/*#__PURE__*/_jsx(TextTag, {
            label: t('AI_TAG'),
            type: "green",
            className: "tw-w-fit tw-mr-1.2 tw-bg-secondary-dark-400 tw-rounded-full tw-text-neutral-light-800 tw-font-caption"
          }), t('AI_LABEL_TITLE_LONG')]
        }), /*#__PURE__*/_jsx(IconButton, {
          customIcon: CloseSmall,
          customColor: colors['neutral-light']['700'],
          customSize: 24,
          xs: true,
          "aria-label": t('AI_CTA_BUTTON'),
          onClick: function onClick() {
            return toogleGeneratedAI(sourceAI);
          }
        })]
      }), /*#__PURE__*/_jsx("section", {
        className: cn(' tw-pt-1.2 tw-mb-2.4 ', stateGenerateAI === 'suggestions' ? 'tw-px-2.4' : 'tw-px-4.8', {
          'tw-flex tw-items-center tw-justify-center': stateGenerateAI === 'loading'
        }),
        children: returnContent()
      }), /*#__PURE__*/_jsxs("section", {
        className: "tw-flex tw-items-center tw-justify-end tw-px-2.4 tw-py-2 tw-bg-neutral-dark-700 tw-border-t tw-border-solid tw-border-neutral-dark-600",
        children: [/*#__PURE__*/_jsx("button", {
          className: cn('tw-btn-tertiary-xs tw-mr-0.8 !tw-text-neutral-dark-500', {
            'tw-hidden': stateGenerateAI === 'loading'
          }),
          type: "button",
          onClick: function onClick() {
            return stateSuggestion ? void generateNoteAction() : toogleGeneratedAI(sourceAI);
          },
          children: t(stateSuggestion ? 'AI_CTA_NEW_BUTTON' : 'CANCEL')
        }), /*#__PURE__*/_jsx("button", {
          type: "button",
          className: cn('tw-btn-primary-xs ', {
            'tw-btn-disabled !tw-bg-neutral-dark-400 !tw-text-neutral-dark-300': disabledButtonAction
          }),
          onClick: handleAction,
          disabled: disabledButtonAction,
          children: t(returnCtaButton)
        })]
      })]
    }), /*#__PURE__*/_jsx(WarningNotes, {
      isVisible: isVisibleToast,
      type: contentToast.type,
      onClose: function onClose() {
        return setIsVisibleToast(false);
      }
    })]
  });
};
export default GenerateNote;